const KeyboardLayout = {
    layout: {
        default: [
            "Q W E \u0118 R T Y U I O \u00D3 P {bksp}",
            "A \u0104 S \u015A D F G H J K L \u0141",
            "Z \u017B \u0179 X C \u0106 V B N \u0143 M",
        ],
        shift: [
            "Q W E \u0118 R T Y U I O \u00D3 P {bksp}",
            "A \u0104 S \u015A D F G H J K L \u0141",
            "Z \u017B \u0179 X C \u0106 V B N \u0143 M",
        ],
    },
};

export default KeyboardLayout